module.exports = __webpack_public_path__ + "static/gthub-0918d78648457def080137b179fc5608.png";